type FilterToolbarProps = {
  leftChildren?: React.ReactNode
  rightChildren?: React.ReactNode
}

export default function FilterToolbar({ leftChildren, rightChildren }: FilterToolbarProps) {
  const searchClass = leftChildren
    ? 'max-w-[400px] l:max-w-[240px]'
    : 'max-w-[var(--container-s-max-w)] mx-auto'

  return (
    <div className="container--outside border-y border-gradient py-xs">
      <section className="container flex justify-between xs:flex-col xs:gap-y-s xs-up:items-center">
        {leftChildren ? <div className="w-full">{leftChildren}</div> : null}

        {rightChildren ? (
          <div className={`${searchClass} w-full xs:max-w-full`}>{rightChildren}</div>
        ) : null}
      </section>
    </div>
  )
}
